'use client';

import { useEffect, useState } from 'react';

export function SiteHeaderWrapper(props: React.ComponentProps<'header'>) {
  const [affix, setAffix] = useState(false);

  useEffect(() => {
    let rafId = 0;

    const onScroll = () => {
      if (rafId) return;
      rafId = requestAnimationFrame(() => {
        rafId = 0;
        setAffix(window.scrollY >= 8);
      });
    };

    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', onScroll);
      if (rafId) cancelAnimationFrame(rafId);
    };
  }, []);

  return <header data-affix={affix} {...props} />;
}
